import { useLayoutEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

/** Route transitions must not inherit a footer's scroll position. */
export function RouteScroll() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();

  useLayoutEffect(() => {
    const entryRoute = /^(\/creer-boutique-manuelle|\/connexion|\/login|\/inscription|\/register|\/essai-gratuit)$/.test(pathname);
    if (navigationType === "POP" && !entryRoute && !hash) return;
    const previous = document.documentElement.style.scrollBehavior;
    const previousRestoration = window.history.scrollRestoration;
    if (entryRoute) window.history.scrollRestoration = "manual";
    document.documentElement.style.scrollBehavior = "auto";
    const scroll = () => {
      const anchor = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
      if (anchor) anchor.scrollIntoView({ behavior: "instant" });
      else window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    };
    scroll();
    const frame = requestAnimationFrame(scroll);
    return () => {
      cancelAnimationFrame(frame);
      document.documentElement.style.scrollBehavior = previous;
      window.history.scrollRestoration = previousRestoration;
    };
  }, [pathname, hash, navigationType]);

  return null;
}